import { Component, ViewEncapsulation, OnInit, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { AccountService, EventManager } from 'src/app/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Dispatcher, StoreInfoUser, StoreResource } from './state';
import { DateUtil } from './shared/util/date.util';
import { ThemeService } from './shared/services/theme.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalService } from 'ng-zorro-antd/modal';
declare let $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'admin-fmarket';
  spinner: number = 0;
  isShowSpinner = false;
  theme: string = 'default';
  constructor(
    private translate: TranslateService,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private notification: NzNotificationService,
    public modalService: NzModalService,
    private localStorage: LocalStorageService,
    private $sessionStorage: SessionStorageService,
    private accountService: AccountService,
    private dispatcher: Dispatcher,
    private toast: ToastrService,
    private themeService: ThemeService,
    private eventManager: EventManager) {
      translate.addLangs(['en_US', 'vi_VN']);
      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang('vi_VN');
      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use('vi_VN');
    }
  ngOnInit() {
    this.changeTheme(this.localStorage.retrieve('theme'));
    this.eventManager.subscribe('show-spinner', (res) => {
      // this.spinnerService.show();
      console.log('show spinner: ', DateUtil.parseDate(new Date(), 'hh:mm:ss'));
      this.isShowSpinner = true;
    });
    this.eventManager.subscribe('close-spinner', (res) => {
      // this.spinnerService.hide();
      console.log('hide spinner: ', DateUtil.parseDate(new Date(), 'hh:mm:ss'));
      this.isShowSpinner = false;
    });
    this.eventManager.subscribe('Fmarket.authenError' , (content) => {
      this.router.navigate(['/authentication/login']);
    });
    this.eventManager.subscribe('Fmarket.httpError' , (content) => {
      if (content.message || content.content) {
        this.toast.error('Error: ', content.message || content.content || 'Error happen');
      }
    });
    this.eventManager.subscribe('change-theme' , (res) => {
      this.changeTheme(res.content.theme);
    });
    this.eventManager.subscribe('comming-soon' , (res) => {
      this.toast.warning('Chức năng đang trong quá trình thực hiên');
    });
    this.eventManager.subscribe('notification' , (res) => {
      this.toast.error('Error: ', res.content.message || 'Error happen');
    });
    this.eventManager.subscribe('create-modal' , (res) => {
      const modal = this.modalService.create(res.content);
    });
    const token = this.$sessionStorage.retrieve('token');
    if (token) {
      this.dispatcher.fire(new StoreResource());
      const profile = this.$sessionStorage.retrieve('profile');
      this.dispatcher.fire(new StoreInfoUser(profile));
      this.accountService.authenticate(profile);
    }
    this.initIgnorepis();
  }
  ngAfterViewInit(): void {
    $('body').on('click', (e) => {
      this.eventManager.broadcast({
        name: 'body-click',
        content: {
          event: e
        }
      })
    });
  }
  initIgnorepis() {
    const ignoreAPIS = [
      'stats/ga-stats'
    ];
    sessionStorage.setItem('ignoreAPIS', JSON.stringify(ignoreAPIS));
  }
  changeTheme(theme) {
    theme = theme || 'default';
    this.theme = theme;
    this.localStorage.store('theme', theme);
    this.themeService.changeTheme(theme);
  }
}
